// Generated by ReScript, PLEASE EDIT WITH CARE

import * as JsxRuntime from "react/jsx-runtime";
import * as BsCssJs$PrezzeeRibbon from "../../../bindings/BsCss/BsCssJs.bs.js";
import * as ThemeContext$PrezzeeRibbon from "../../../context/ThemeContext/ThemeContext.bs.js";
import * as Theme__Responsive$PrezzeeRibbon from "../../../theme/Theme__Responsive.bs.js";

function block(theme) {
  var match = theme.components;
  var downloadAppsBanner = match.downloadAppsBanner;
  return BsCssJs$PrezzeeRibbon.style([
              BsCssJs$PrezzeeRibbon.display("flex"),
              BsCssJs$PrezzeeRibbon.boxSizing("borderBox"),
              BsCssJs$PrezzeeRibbon.flexDirection("column"),
              BsCssJs$PrezzeeRibbon.width(BsCssJs$PrezzeeRibbon.px(125)),
              BsCssJs$PrezzeeRibbon.minWidth(BsCssJs$PrezzeeRibbon.px(125)),
              BsCssJs$PrezzeeRibbon.borderRadius(theme.borderRadius),
              BsCssJs$PrezzeeRibbon.color(downloadAppsBanner.headingColor),
              BsCssJs$PrezzeeRibbon.backgroundColor(downloadAppsBanner.blockBackgroundColor),
              BsCssJs$PrezzeeRibbon.marginRight(BsCssJs$PrezzeeRibbon.rem(0.375)),
              BsCssJs$PrezzeeRibbon.paddingLeft(BsCssJs$PrezzeeRibbon.rem(1.25)),
              BsCssJs$PrezzeeRibbon.paddingRight(BsCssJs$PrezzeeRibbon.rem(1.25)),
              BsCssJs$PrezzeeRibbon.paddingTop(BsCssJs$PrezzeeRibbon.rem(1.375)),
              BsCssJs$PrezzeeRibbon.paddingBottom(BsCssJs$PrezzeeRibbon.rem(1.375)),
              BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.smallScreenOrMobile, [
                    BsCssJs$PrezzeeRibbon.marginRight(BsCssJs$PrezzeeRibbon.px(0)),
                    BsCssJs$PrezzeeRibbon.marginBottom(BsCssJs$PrezzeeRibbon.rem(0.375)),
                    BsCssJs$PrezzeeRibbon.width("auto"),
                    BsCssJs$PrezzeeRibbon.height(BsCssJs$PrezzeeRibbon.px(56)),
                    BsCssJs$PrezzeeRibbon.paddingTop(BsCssJs$PrezzeeRibbon.rem(0.75)),
                    BsCssJs$PrezzeeRibbon.paddingBottom(BsCssJs$PrezzeeRibbon.rem(0.75)),
                    BsCssJs$PrezzeeRibbon.paddingLeft(BsCssJs$PrezzeeRibbon.rem(1.5)),
                    BsCssJs$PrezzeeRibbon.flexDirection("row"),
                    BsCssJs$PrezzeeRibbon.alignItems("center")
                  ]),
              BsCssJs$PrezzeeRibbon.selector("img", [
                    BsCssJs$PrezzeeRibbon.width(BsCssJs$PrezzeeRibbon.px(32)),
                    BsCssJs$PrezzeeRibbon.marginBottom(BsCssJs$PrezzeeRibbon.px(5)),
                    BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.smallScreenOrMobile, [
                          BsCssJs$PrezzeeRibbon.marginRight(BsCssJs$PrezzeeRibbon.rem(0.75)),
                          BsCssJs$PrezzeeRibbon.marginBottom(BsCssJs$PrezzeeRibbon.zero)
                        ])
                  ])
            ]);
}

var Styles = {
  block: block
};

function DownloadAppsBanner__Block(props) {
  var theme = ThemeContext$PrezzeeRibbon.useTheme(undefined);
  return JsxRuntime.jsx("div", {
              children: props.children,
              className: block(theme)
            });
}

var make = DownloadAppsBanner__Block;

export {
  Styles ,
  make ,
}
/* react/jsx-runtime Not a pure module */
